import { IconButton, Tooltip } from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";
import useExplorerUrl from "src/hooks/useExplorerUrl";

export default function ExternalLinkButton({ hash, config, butProps, iconProps }) {
  const { link, text } = useExplorerUrl(hash, config);

  return (
    <Tooltip title={`Open in ${text}`} placement="top">
      <IconButton href={link} target="_blank" {...butProps}>
        <LaunchIcon {...iconProps} style={{ ...{ fontSize: "16px" }, ...iconProps?.style }} />
      </IconButton>
    </Tooltip>
  );
}
